import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../utils/AuthContext';

export default function AppBottomNavigation({ currentPage }) {

  const { auth } = useContext(AuthContext);

  const navigationItems = [
    { label: 'Overview', to: '/overview', icon: <DashboardOutlinedIcon />, userType: 'Admin' },
    { label: 'Clients', to: '/clients', icon: <PeopleAltOutlinedIcon /> },
    { label: 'Referrals', to: '/referrals', icon: <PersonAddAltOutlinedIcon /> },
    { label: 'Users', to: '/users', icon: <ManageAccountsOutlinedIcon />, userType: 'Agent' },
    { label: 'Profile', to: '/profile', icon: <SettingsOutlinedIcon /> },
  ];

  // Filter navigation items based on user type
  const filteredNavigationItems = navigationItems.filter(item => {
    if (auth.user.user_type === 'Agent' && item.label === 'Users') {
      return false; // Remove Users page for regular users
    }
    if (auth.user.user_type === 'Admin' && item.label === 'Overview') {
      return false; // Remove Overview page for admins
    }
    return true; // Keep other items
  });

  function getValue() {
    if (auth.user.user_type === 'Admin') {
      if (currentPage === "clients") {
        return 0;
      } else if (currentPage === "referrals") {
        return 1;
      } else if (currentPage === "users") {
        return 2;
      } else if (currentPage === "profile") {
        return 3;
      }
    } else if (auth.user.user_type === 'Agent') {
      if (currentPage === "overview") {
        return 0;
      } else if (currentPage === "clients") {
        return 1;
      } else if (currentPage === "referrals") {
        return 2;
      } else if (currentPage === "profile") {
        return 3;
      }
    }
    
  }

  return (
    <Box>
      <BottomNavigation showLabels value={getValue()}>
        {filteredNavigationItems.map(item => (
          <BottomNavigationAction
            key={item.to}
            LinkComponent={Link}
            to={item.to}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Box>
  );
}